module.exports = __webpack_public_path__ + "img/icon_correct.f587bbf6.png";